import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { BaseNotification } from '@app/components/common/BaseNotification/BaseNotification';
import { capitalize } from '@app/utils/utils';
import * as S from './NotificationsOverlay.styles';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseSpace } from '@app/components/common/BaseSpace/BaseSpace';
import { NotificationResponse } from '@app/api/notificationCenter.api';

interface NotificationsOverlayProps {
  notifications: NotificationResponse[];
  setNotifications: (state: NotificationResponse[]) => void;
  markAsRead?: (id: number) => void;
  removeNotification?: (id: number) => void;
}

export const NotificationsOverlay: React.FC<NotificationsOverlayProps> = ({
  notifications,
  setNotifications,
  markAsRead,
  removeNotification,
  ...props
}) => {
  const { t } = useTranslation();

  const noticesList = useMemo(
    () =>
      notifications.map((notification, index) => {
        return (
          <BaseNotification
            id={notification.id}
            key={index}
            type={'warning'}
            title={t(notification.title)}
            description={t(notification.message)}
            className={notification.isRead ? "" : "new-notification"}
            showRead={notification.isRead ? false : true}
            showDelete={notification.isRead ? true : false}
            onRead={() => markAsRead && markAsRead(notification.id)}
            onDelete={() => removeNotification && removeNotification(notification.id)}
          />
        );
      }),
    [notifications, t],
  );

  return (
    <S.NoticesOverlayMenu {...props}>
      <BaseRow gutter={[20, 20]}>
        <BaseCol span={24}>
          {notifications.length > 0 ? (
            <BaseSpace size={0} direction="vertical" className='notifications-wrapper' split={<S.SplitDivider />}>
              {noticesList}
            </BaseSpace>
          ) : (
            <S.Text>{t('header.notifications.noNotifications')}</S.Text>
          )}
        </BaseCol>
        <BaseCol span={24}>
          <BaseRow gutter={[10, 10]}>
            <BaseCol span={24}>
              <S.Btn type="link">
                <Link to="/notification-center">{t('header.notifications.viewAll')}</Link>
              </S.Btn>
            </BaseCol>
          </BaseRow>
        </BaseCol>
      </BaseRow>
    </S.NoticesOverlayMenu>
  );
};
